import React, { Component } from "react";
import axios from "axios";
import { BASE_URL, HEADERS } from "../../common/api";
import ClientTable from "../../assets/js/ClientTabe"; // Импортируем новый компонент

const columns = [
  { field: "name", header: "Имя" },
  { field: "phone", header: "Номер телефона" },
  { field: "company", header: "Компания" },
  { field: "comment", header: "Коментария" },
  { field: "created_at", header: "Дата регистрации" },
];

export class PartnerLead extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      loading: true,
      error: null,
    };
  }

  componentDidMount() {
    this.fetchDesingerLeads();
  }

  fetchDesingerLeads = () => {
    axios
      .get(BASE_URL + "partners/", HEADERS)
      .then((res) => {
        this.setState({
          data: res.data,
          loading: false,
        });
      })
      .catch((error) => {
        console.error("Ошибка загрузки клиентов:", error);
        this.setState({
          error: "Не удалось загрузить данные клиентов",
          loading: false,
        });
      });
  };

  handleView = (row) => {
    console.log("Просмотр клиента:", row);
    // Логика просмотра
  };


  render() {
    const { data, loading, error } = this.state;

    if (loading) {
      return (
        <div className="text-center p-5">
          <div className="spinner-border" role="status">
            <span className="sr-only">Загрузка...</span>
          </div>
        </div>
      );
    }

    if (error) {
      return <div className="alert alert-danger m-3">{error}</div>;
    }

    return (
      <div className="container-fluid p-4">
        <ClientTable
          data={data}
          columns={columns}
          title="Запрос от партнеров"
          onView={this.handleView}
        />
      </div>
    );
  }
}

export default PartnerLead;